<template>
  <inline-svg v-if="routeId === '3600'" :src="require('@/assets/icons/tram.svg')" :style="color ? {fill: color} : null" />
  <inline-svg v-else :src="require('@/assets/icons/bus.svg')" :style="color ? {fill: color} : null" />
</template>

<script>
export default {
  name: "RouteLogo",
  props: {
    routeId: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: null
    }
  }
};
</script>
